import '@expo/metro-runtime'; // https://github.com/expo/expo/issues/23104#issuecomment-1689566248

import './index.js';
